import { commaValueFormatter, Select } from '@eleveo/components-react';
import React, { useCallback, useState } from 'react';
import { useField } from 'react-final-form';

import { RoleOption } from '../../roles/types';

export type RoleMappingSelectProps = {
  role: RoleOption;
  field: string;
} & Pick<
  React.ComponentPropsWithoutRef<typeof Select>,
  'isDisabled' | 'testId' | 'defaultSelectedKeys' | 'options' | 'validationState' | 'disabledKeys' | 'className'
>;

export const RoleMappingSelect: React.FC<RoleMappingSelectProps> = ({
  role: { name: roleName, id: roleId },
  field,
  testId,
  isDisabled,
  defaultSelectedKeys,
  options,
  validationState,
  disabledKeys,
  className,
}) => {
  const {
    input: { onChange, onBlur, onFocus },
  } = useField(field, { subscription: {} });

  const [isOpened, setIsOpened] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState<Set<React.Key>>(new Set());

  const submit = useCallback(
    (submittedRoles?: Set<React.Key>) => {
      const newRoles = submittedRoles ?? selectedRoles;
      if (!newRoles) {
        // nothing to update
        return;
      }

      onChange(Array.from(newRoles));
      setSelectedRoles(newRoles);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, selectedRoles]
  );

  return (
    <Select
      isDisabled={isDisabled}
      className={className}
      defaultSelectedKeys={defaultSelectedKeys}
      isClearable
      isSearchable
      key={roleId}
      label={roleName}
      onSelectionChange={(values) => {
        if (isOpened) {
          setSelectedRoles(values);
          return;
        }

        // change on values when select is closed: eg. clear button
        submit(values);
      }}
      onOpenChange={(isOpen) => {
        setIsOpened(isOpen);
        if (isOpen) {
          return;
        }

        submit();
      }}
      onFocus={onFocus}
      onBlur={onBlur}
      options={options}
      selectionMode="multiple"
      validationState={validationState}
      valueFormatter={commaValueFormatter}
      testId={testId}
      disabledKeys={disabledKeys}
    />
  );
};
